import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeTagAction } from '../../reducers/actions';
import { TagService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_TAG),
    switchMap(action =>
      TagService.delete(action.tag, store).pipe(
        map(() => removeTagAction(action.tag, action.areaId)),
        catchError(retryAuthentication(action$, 'epics/tags/deleteTag'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/deleteTag.js